if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;
      
      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 0));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });

      // Prev/next arrows overlaid on the main media (Desktop navigation style = Arrows).
      // Step through media in thumbnail order, updating the featured media and the
      // active thumbnail; loops at the ends. No-op when the arrows aren't rendered.
      this.mediaNavButtons = this.elements.viewer.querySelectorAll('.product__media-nav');
      this.mediaNavButtons.forEach((button) => {
        const direction = button.classList.contains('product__media-nav--prev') ? -1 : 1;
        button.addEventListener('click', (event) => {
          event.preventDefault();
          this.stepMedia(direction);
        });
      });
      
      if (this.dataset.desktopLayout !== 'stacked' && this.mql.matches) this.removeListSemantic();

      this.stackedThumbnails = this.dataset.desktopLayout === 'stacked' && this.elements.thumbnails.classList.contains('thumbnail-slider--stacked');
      if (this.stackedThumbnails) this.observeStackedMedia();

      const clientWidth = Math.round(document.body.clientWidth);
      const mainSlieder = this.elements?.viewer?.slider;

      if (mainSlieder && clientWidth < 750 && this.dataset.mobileLayout != 'stacked') {
        const currentMedia = mainSlieder.querySelectorAll('.product-media')?.[0];
        mainSlieder.style.height = `${currentMedia?.clientHeight}px` || 'auto';
      }

      window.addEventListener('resize', () => {
        const clientWidth = Math.round(document.body.clientWidth);
        if (clientWidth < 750 && this.dataset.mobileLayout != 'stacked') {
          const currentMedia = mainSlieder?.querySelectorAll('.product-media')?.[0];
          if (mainSlieder) mainSlieder.style.height = `${currentMedia?.clientHeight}px` || 'auto';
        } else {
          if (mainSlieder) mainSlieder.style.height = 'unset';
        }
      });
    }

    onSlideChanged(event) {
      const mediaId = event.detail?.currentElement?.dataset?.mediaId || '';
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      
      const productCounter = document.querySelector('.mobile-product-counter');
      
      if (productCounter) {
          productCounter.innerHTML = `${event.detail.currentPage}/${event.detail.totalPages}`
      }

      const clientWidth = Math.round(document.body.clientWidth);
      if (clientWidth < 750) {
        const currentMedia = activeMedia.querySelector('.product-media');
        const mainSlieder = this.elements?.viewer?.slider;
        
        if (mainSlieder) mainSlieder.style.height = `${currentMedia?.clientHeight}px` || 'auto';
      }
      // if (!thumbnail) return;
      // this.setActiveThumbnail(thumbnail);
    }

    stepMedia(direction) {
      if (!this.elements.thumbnails) return;
      const items = Array.from(this.elements.thumbnails.querySelectorAll('[data-target]'));
      if (!items.length) return;
      let index = items.findIndex((item) => item.querySelector('button')?.getAttribute('aria-current') === 'true');
      if (index === -1) {
        const active = this.elements.viewer.querySelector('[data-media-id].is-active');
        if (active) index = items.findIndex((item) => item.dataset.target === active.dataset.mediaId);
      }
      if (index === -1) index = 0;
      const nextIndex = (index + direction + items.length) % items.length;
      const target = items[nextIndex].dataset.target;
      if (target) this.setActiveMedia(target, false);
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      if (!activeMedia) return;
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      if (this.dataset.desktopLayout == 'thumbnail_bottom_2') {
        const nextMediaElement = activeMedia.nextElementSibling;
        if (nextMediaElement) {
          nextMediaElement.classList.add('is-active');
        } else {
          const prevMediaElement = activeMedia.previousElementSibling;
          if (prevMediaElement) prevMediaElement.classList.add('is-active');
        }
      }
      
      activeMedia.classList.add('is-active');

      activeMedia.classList.add('media-slide-in');
      activeMedia.addEventListener('animationend', () => {
        activeMedia.classList.remove('media-slide-in');
      }, { once: true });

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          if (activeThumbnail) activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.stackedThumbnails && this.mql.matches) {
          // Only scroll the page for user-initiated changes (thumbnail click, arrows).
          // First load / variant sync call this with prepend=true (and prepend the
          // featured media to the top); scrolling there would yank a shopper who has
          // already scrolled down back to the top of the page.
          if (!prepend) this.scrollToStackedMedia(activeMedia);
          return;
        }
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail?.dataset?.mediaPosition);

      // Keep the zoom view on the same image so it opens on the right one next.
      const zoom = document.getElementById(`ProductZoom-${this.id.replace('MediaGallery-', '')}`);
      if (zoom && typeof zoom.setActive === 'function') {
        const opener = activeMedia.querySelector('.opener');
        if (opener) zoom.setActive(opener.dataset.mediaId);
      }
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.stackedThumbnails && this.mql.matches) {
        this.revealStackedThumbnail(thumbnail);
        return;
      }
      if (this.elements.thumbnails.slider && this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    // Stacked layout with thumbnails: the page scrolls, the strip stays put
    scrollToStackedMedia(media) {
      const offset = parseFloat(getComputedStyle(this.elements.thumbnails).top) || 0;
      const top = media.getBoundingClientRect().top + window.scrollY - offset;
      this.suppressStackedTracking = Date.now() + 800;
      window.scrollTo({ top, behavior: 'smooth' });
    }

    revealStackedThumbnail(thumbnail) {
      const list = this.elements.thumbnails.slider;
      if (!list) return;
      const top = thumbnail.getBoundingClientRect().top - list.getBoundingClientRect().top + list.scrollTop;
      const bottom = top + thumbnail.offsetHeight;
      if (top >= list.scrollTop && bottom <= list.scrollTop + list.clientHeight) return;
      list.scrollTo({ top: top - (list.clientHeight - thumbnail.offsetHeight) / 2 });
    }

    observeStackedMedia() {
      const items = this.elements.viewer.querySelectorAll('[data-media-id]');
      if (!items.length || !('IntersectionObserver' in window)) return;
      const ratios = new Map();
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => ratios.set(entry.target, entry.intersectionRatio));
        if (!this.mql.matches || Date.now() < (this.suppressStackedTracking || 0)) return;
        let best = null;
        ratios.forEach((ratio, item) => {
          if (ratio > 0 && (!best || ratio > ratios.get(best))) best = item;
        });
        if (!best) return;
        const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${best.dataset.mediaId}"]`);
        if (thumbnail && thumbnail.querySelector('button').getAttribute('aria-current') !== 'true') this.setActiveThumbnail(thumbnail);
      }, { threshold: [0, 0.25, 0.5, 0.75, 1] });
      items.forEach((item) => observer.observe(item));
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);

      if (this.dataset.autoplayVideo === 'true') {
        window.setTimeout(() => {
          const nativeVideo = activeItem.querySelector('video');
          if (nativeVideo) {
            nativeVideo.play();
            return;
          }
          const iframe = activeItem.querySelector('iframe');
          if (iframe) {
            const src = iframe.src || '';
            if (src.includes('youtube.com') || src.includes('youtu.be')) {
              iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
            } else if (src.includes('vimeo.com')) {
              iframe.contentWindow.postMessage('{"method":"play"}', '*');
            }
          }
        }, 100);
      }
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
